module.exports = __webpack_public_path__ + "static/media/logo (5).a6de10dd.png";